export type ShippingExcelSort = 'entry' | 'settlement';

/**
 * 배송엑셀 행 정렬 — 스펙: docs/superpowers/specs/2026-10-06-shipping-excel-settlement-order-design.md
 * - entry: 입력 배열(= row_order → created_at → id fetch 순서) 그대로, 참조 동일.
 * - settlement: 정산서 연결 행은 order_id ASC(정산서 등록 순서), 미연결 행(배송엑셀 직접 추가)은
 *   뒤에 입력 순서 유지. 새 배열을 반환한다 — React state를 제자리 정렬하면 entry로 되돌릴 수 없다.
 */
export function sortShippingRows<T extends { order_id?: number | null }>(rows: T[], mode: ShippingExcelSort): T[] {
  if (mode === 'entry') return rows;
  return [...rows].sort((a, b) => {
    const oa = typeof a.order_id === 'number' ? a.order_id : null;
    const ob = typeof b.order_id === 'number' ? b.order_id : null;
    if (oa !== null && ob !== null) return oa - ob;
    if (oa !== null) return -1;
    if (ob !== null) return 1;
    return 0; // 미연결 행끼리는 stable sort로 입력 순서 유지
  });
}
